"use client"

import * as authRepository from "components/shopFeatures/auth/authRepository"
import { initAuth } from "components/shopFeatures/auth/authSlice"
import Wizard from "components/shopFeatures/wizard/Wizard"
import { useParams } from "next/navigation"
import { useEffect, useState } from "react"
import { HashRouter } from "react-router-dom"
import { useAppDispatch, useTypedSelector } from "store"
import { fetchShowRooms } from "../showRooms/showRoomsSlice"
import { fetchModel } from "./wizardSlice"

export default function WizardClient({ modelId }: { modelId?: string }) {
  const dispatch = useAppDispatch()
  const params = useParams()
  const currentModelId = modelId || (params?.model as string)
  const { model } = useTypedSelector((state) => state.wizard)
  const modelIdInStore = model?.id
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  useEffect(() => {
    async function initialize() {
      const token = await authRepository.getToken()

      // Always dispatch initAuth, even with null token to set initialized = true
      dispatch(initAuth(token))
      dispatch(fetchShowRooms())
    }
    initialize()
  }, [dispatch])

  // Ensure the selected model stays in sync with route/prop modelId changes.
  useEffect(() => {
    const hasModelMismatch =
      !!currentModelId &&
      modelIdInStore !== undefined &&
      String(modelIdInStore) !== String(currentModelId)

    if (currentModelId && (modelIdInStore === undefined || hasModelMismatch)) {
      dispatch(fetchModel(currentModelId))
    }
  }, [dispatch, currentModelId, modelIdInStore])

  if (!isMounted) {
    return null
  }

  return (
    <HashRouter>
      <Wizard />
    </HashRouter>
  )
}
